import React from "react";

import DefaultToggleableTabs from "@sendmagic/prismic-nextjs/src/components/slices/ToggleableTabs/variations/Default";
import ToggleableTabsVersionTwo from "@sendmagic/prismic-nextjs/src/components/slices/ToggleableTabs/variations/Version-2";

const VARIANT = "v2";

const ToggleableTabs = ({ doc, ...rest }) => {
  const { slice_label } = doc;

  if (slice_label === VARIANT) return <ToggleableTabsVersionTwo doc={doc} {...rest} />;
  return <DefaultToggleableTabs doc={doc} {...rest} />;
};

export default ToggleableTabs;
